// QR Code generation utilities for tournament sharing
// Uses a public QR code API to generate codes without additional dependencies

/**
 * Generate a QR code URL for a given data string
 * Uses the goqr.me API which is free and reliable
 * @param {string} data - The data to encode (usually a URL)
 * @param {number} size - Size in pixels (default 200)
 * @returns {string} URL to the QR code image
 */
export const generateQRCodeUrl = (data, size = 200) => {
  const encodedData = encodeURIComponent(data);
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodedData}&format=png&margin=10`;
};

/**
 * Generate a tournament share URL
 * @param {string} shareUrl - The tournament's share URL slug
 * @returns {string} Full tournament URL
 */
export const getTournamentShareUrl = (shareUrl) => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/t/${shareUrl}`;
};

/**
 * Generate a QR code URL for a tournament
 * @param {string} shareUrl - The tournament's share URL slug
 * @param {number} size - Size in pixels
 * @returns {string} URL to the QR code image
 */
export const generateTournamentQRCode = (shareUrl, size = 200) => {
  const tournamentUrl = getTournamentShareUrl(shareUrl);
  return generateQRCodeUrl(tournamentUrl, size);
};

/**
 * Download a QR code as an image
 * @param {string} qrCodeUrl - The QR code image URL
 * @param {string} filename - The filename to save as
 */
export const downloadQRCode = async (qrCodeUrl, filename = 'tournament-qr-code.png') => {
  try {
    const response = await fetch(qrCodeUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading QR code:', error);
    // Fallback: open in new tab
    window.open(qrCodeUrl, '_blank');
  }
};
